import moment from "moment";

export const DRIVER_LOCATION_ACTIVE_MINUTES = 5;

export function getLatestDriverLocation(locations, driverId) {
  if (!locations || driverId == null) {
    return null;
  }
  const entry =
    locations[driverId] ??
    locations[String(driverId)] ??
    locations[Number(driverId)];
  if (!entry?.length) {
    return null;
  }
  return entry[0];
}

function parseLocationTimestamp(raw) {
  if (!raw) {
    return null;
  }
  const parsed = moment(raw);
  return parsed.isValid() ? parsed : null;
}

/**
 * Best available "last seen" time for map/sidebar.
 * Uses the newer of client_datetime and datetime because client_datetime was
 * historically stored in UTC while datetime uses server local time (-2h in DE).
 */
export function getDriverLocationLastSignal(location) {
  if (!location) {
    return null;
  }

  const client = parseLocationTimestamp(location.client_datetime);
  const server = parseLocationTimestamp(location.datetime);

  if (client && server) {
    return client.isAfter(server) ? client : server;
  }

  return client || server;
}

export function isDriverLocationActive(location, now = moment()) {
  const lastSignal = getDriverLocationLastSignal(location);
  if (!lastSignal) {
    return false;
  }
  if (!lastSignal.isSame(now, "day")) {
    return false;
  }
  return lastSignal.isAfter(
    now.clone().subtract(DRIVER_LOCATION_ACTIVE_MINUTES, "minutes")
  );
}

export function formatDriverLocationUpdatedAt(location) {
  const lastSignal = getDriverLocationLastSignal(location);
  if (!lastSignal) {
    return null;
  }
  return lastSignal.format("DD.MM.YYYY HH:mm");
}

export function getDriverSearchText(driver) {
  if (!driver) {
    return "";
  }
  return [driver.firstname, driver.lastname, driver.ext_id, driver.tour]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function compareDriversByName(driverA, driverB) {
  const nameA = `${driverA?.firstname || ""} ${driverA?.lastname || ""}`.trim();
  const nameB = `${driverB?.firstname || ""} ${driverB?.lastname || ""}`.trim();
  return nameA.localeCompare(nameB, "de", { sensitivity: "base" });
}

export function compareDriversByLastOnline(driverA, driverB, locations) {
  const signalA = getDriverLocationLastSignal(
    getLatestDriverLocation(locations, driverA?.id)
  );
  const signalB = getDriverLocationLastSignal(
    getLatestDriverLocation(locations, driverB?.id)
  );

  if (!signalA && !signalB) {
    return compareDriversByName(driverA, driverB);
  }
  if (!signalA) {
    return 1;
  }
  if (!signalB) {
    return -1;
  }
  return signalB.valueOf() - signalA.valueOf();
}
